import {Stack, Flex, Button, Select, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect, useCallback, useMemo} from 'react'
import {useIntl} from 'react-intl'
import TextAreaComponent from '../../../../components/field/text-area-component'
import {useForm, useWatch} from 'react-hook-form'
import debounce from 'lodash/debounce'
import {remCalc} from '../../../../theme/_utils'

//maybe remove onSubmit from props and make the call directly here?
const OrderCancellationForm = React.memo(({onSubmit}) => {
    // const [reason, setReason] = useState('')
    // const [textArea, setTextArea] = useState('')
    // const timeoutRef = useRef(null)
    const styles = useMultiStyleConfig('Orders')
    const {handleSubmit, control, setValue} = useForm({
        mode: 'all',
        defaultValues: {
            reason: '',
            cancellationDetails: '',
        },
    })
    const {formatMessage} = useIntl()

    const reason = useWatch({
        control,
        name: 'reason',
    })
    const textArea = useWatch({
        control,
        name: 'cancellationDetails',
    })

    const submit = useCallback(
        (formData) => {
            const {reason, cancellationDetails} = formData
            // formData.preventDefault()
            reason && onSubmit(reason, cancellationDetails)
        },
        [onSubmit],
    )

    const handleChange = (event) => {
        const {value} = event.target
        setValue('cancellationDetails', value)
    }

    const debouncedTextArea = useMemo(
        () =>
            debounce((input) => {
                setValue('cancellationDetails', input)
            }, 200),
        [setValue],
    )

    useEffect(() => {
        if (!textArea) return
        debouncedTextArea(textArea)
        return () => debouncedTextArea.cancel()

        // timeoutRef.current = setTimeout(() => {
        //     setTextArea(textArea)
        // }, 200)
        // return () => clearTimeout(timeoutRef.current)
    }, [textArea, debouncedTextArea])

    const options = useMemo(
        () => [
            {
                label: formatMessage({
                    id: 'account_order_detail.options.wrong_product',
                    defaultMessage: 'Wrong product',
                }),
                value: '03',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.quantity',
                    defaultMessage: 'Wrong quantity',
                }),
                value: '04',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.change_of_mind',
                    defaultMessage: 'Change of mind',
                }),
                value: '05',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.wrong_delivery_address',
                    defaultMessage: 'Wrong delivery address',
                }),
                value: '06',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.double_order',
                    defaultMessage: 'Double order',
                }),
                value: '07',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.wrong_payment_method',
                    defaultMessage: 'Wrong payment method',
                }),
                value: '08',
            },
            {
                label: formatMessage({
                    id: 'account_order_detail.options.other_reason',
                    defaultMessage: 'Other reason',
                }),
                value: '09',
                isOther: true,
            },
        ],
        [],
    )

    const selectedOption = options.find((opt) => opt.value === reason)

    useEffect(() => {
        // edge case
        if (!selectedOption?.isOther && textArea !== '') setValue('cancellationDetails', '')
    }, [selectedOption, textArea, setValue])

    return (
        <form onSubmit={handleSubmit(submit)}>
            <Flex {...styles.formCancellationContainer}>
                <Stack {...styles.formCancellationStack}>
                    <Select
                        value={reason}
                        onChange={(e) => {
                            setValue('reason', e.target.value)
                        }}
                        placeholder={formatMessage({
                            id: 'account_order_detail.select_cancellation_reason_placeholder',
                            defaultMessage: 'Select cancellation reason',
                        })}
                        {...styles.formCancellationSelectText}
                        isRequired
                    >
                        {options.map((opt) => (
                            <option key={opt?.value} value={opt?.value}>
                                {opt?.label}
                            </option>
                        ))}
                    </Select>
                    {selectedOption?.isOther && (
                        <TextAreaComponent
                            placeholder="Other"
                            onChange={handleChange}
                            value={textArea}
                        />
                    )}
                </Stack>

                <Button type="submit" variant="primary" isDisabled={!reason} w={{lg: remCalc(213)}}>
                    {formatMessage({
                        id: 'account_order_detail.button.cancel_order',
                        defaultMessage: 'Cancel order',
                    })}
                </Button>
            </Flex>
        </form>
    )
})

OrderCancellationForm.propTypes = {
    onSubmit: PropTypes.func,
}
OrderCancellationForm.displayName = 'order-cancellation-form'
export default OrderCancellationForm
